/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { parametersFilterDelete } from '../models/parametersFilterDelete';
import type { responsesPartMeta } from '../models/responsesPartMeta';
import type { translationTerminology } from '../models/translationTerminology';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TranslationTerminologiesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count translationTerminologies
   * Count translationTerminologies (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of translationTerminology documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsTranslationTerminologiesCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/translationTerminologies/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one translationTerminology
   * Find one translationTerminology by its unique identifier.
   * @param identifier translationTerminology unique identifier
   * @returns any One translationTerminology document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsTranslationTerminologies(
    identifier: string,
  ): CancelablePromise<{
    data?: translationTerminology;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/translationTerminologies/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete one translationTerminology
   * Delete one translationTerminology
   * @param identifier translationTerminology unique identifier
   * @returns any delete status translationTerminologies. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceorganizationsTranslationTerminologies(
    identifier: string,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/translationTerminologies/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many translationTerminologies
   * Find many translationTerminologies (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many translationTerminology documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsTranslationTerminologies1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<translationTerminology>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/translationTerminologies',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete many translationTerminologies
   * Delete many translationTerminologies using filtering. You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any delete status translationTerminologies. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceorganizationsTranslationTerminologies1(
    filter?: parametersFilterDelete,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/translationTerminologies',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

}
